"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var _default = function _default(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    width: "24",
    height: "24",
    fill: "#004864"
  }, props), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M8,4.1V8H4.12V4.1H8M9.59,2.51H2.53V9.57H9.59V2.51Z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M19.84,4.1V8H16V4.1h3.88m1.59-1.59H14.37V9.57h7.06V2.51Z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M8,15.92V19.8H4.14V15.92H8m1.59-1.59H2.55v7.06H9.61V14.33Z"
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    x: "11.18",
    y: "2.5",
    width: "1.65",
    height: "1.65"
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    x: "11.18",
    y: "4.15",
    width: "1.65",
    height: "4.68"
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    x: "16.77",
    y: "12",
    width: "4.71",
    height: "1.59"
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    x: "8.53",
    y: "12",
    width: "8.41",
    height: "1.59"
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    x: "2.5",
    y: "10.41",
    width: "3.36",
    height: "1.59"
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    x: "11.6",
    y: "15.95",
    width: "5.18",
    height: "1.59"
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    x: "17.13",
    y: "17.11",
    width: "1.65",
    height: "7.09",
    transform: "translate(-2.7 38.61) rotate(-90)"
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    x: "19.85",
    y: "15.95",
    width: "1.65",
    height: "5.51",
    transform: "translate(41.35 37.41) rotate(180)"
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    x: "14.35",
    y: "19.91",
    width: "1.65",
    height: "1.59"
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    x: "19.83",
    y: "18.35",
    width: "1.65",
    height: "3.12"
  }));
};

exports["default"] = _default;